<template>
  <hic-dialog fullscreen title="患者卡片" :visible="visible" @close="close" @open="open" destroy-on-close>
    <template slot="title">
      <el-row type="flex" justify="space-around" align="middle" style="flex-wrap: wrap">
        <el-link @click.native="meta.showDrawer = true" style="padding-bottom: 5px" type="primary" class="left-pad">
          <h2 style="margin: 0">{{ current.patientName }}</h2>
        </el-link>
        <span class="info">{{ current.patientGender | dictText("Gender") }} {{ current.patientAge }} </span>
        <span class="success">{{ current.ipType }}</span>
        <span class="info">床位：{{ current.bedNo }}床</span>
        <el-link v-if="!!diagnosisTabName" type="primary" :href="`/#/${diagnosisTabName}`" style="font-size: 1rem; margin: 0">诊断：{{ current.diagnosisName }}</el-link>
        <span v-else class="info">诊断：{{ current.diagnosisName }}</span>
        <span>
          <span class="info">护理等级：</span><span class="warning">{{ current.nursingGrade }}</span>
        </span>
        <span>
          <span class="info">危重等级：</span><span class="warning">{{ current.criticalLevel }}</span>
        </span>
        <span class="info">过敏：{{ current.patientAllergyDrugs }}</span>
        <span class="info">血型：{{ current.patientBloodType }}</span>
        <span class="info">住院号：{{ current.ipNo }}</span>
      </el-row>
    </template>
    <el-container class="f-h">
      <el-header>
        <el-menu :default-active="$route.name" mode="horizontal" @select="menuClick" router>
          <slot name="menus" />
        </el-menu>
      </el-header>
      <el-main style="padding: 0 0 0 0">
        <keep-alive>
          <router-view v-if="!$route.isComponent" :entity="current" />
        </keep-alive>
        <slot name="main" :data="current" />
      </el-main>
    </el-container>
    <template slot="footer">
      <el-row type="flex" justify="space-between" align="middle">
        <hic-hospitalization-tags :entity="current" />
        <el-tag type="info" effect="light" style="font-size: 1rem">
          <small>科室：</small><span>{{ current.deptCode | dictText("Dept") }}</span> <small>住院医师：</small><span>{{ current.doctorName }}</span> <small>责任护士：</small><span>{{ current.nurseName }}</span> <small>主治医师：</small><span>{{ current.masterName }}</span> <small>主任医师：</small
          ><span>{{ current.directorName }}</span>
        </el-tag>
      </el-row>
    </template>
    <el-drawer title="切换患者" :visible.sync="meta.showDrawer" direction="ltr" append-to-body size="20rem" :modal="false" :with-header="false">
      <h5 class="left-pad info">科室患者：</h5>
      <el-table v-if="patients && patients.length" :data="patients" :show-header="false">
        <el-table-column label="姓名" prop="patientName">
          <template slot-scope="{ row }">
            <el-row type="flex" align="middle">
              <el-link v-if="current.ipNo != row.ipNo" type="primary" @click="switchPatient(row)" class="left-pad">
                <span class="bold-title">{{ row.bedNo }}床</span> <i class="el-icon-user-solid" /> <span>{{ row.patientName }}</span> {{ row.patientGender | dictText("Gender") }} {{ row.patientAge }}
              </el-link>
              <span v-else class="left-pad info">
                <span class="bold-title">{{ row.bedNo }}床</span> <i class="el-icon-user-solid" /> <span>{{ row.patientName }}</span> {{ row.patientGender | dictText("Gender") }} {{ row.patientAge }}
              </span>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <h5 v-if="!setting.isSimple" class="left-pad info">会诊患者：</h5>
      <el-table v-if="!setting.isSimple && consultations && consultations.length" :data="patients" :show-header="false">
        <el-table-column label="姓名" prop="patientName">
          <template slot-scope="{ row }">
            <el-row type="flex" align="middle">
              <el-avatar icon="el-icon-user-solid" shape="square" :size="24"></el-avatar> <el-link :type="current.ipNo == row.ipNo ? 'primary' : 'info'" @click="switchPatient(row)" class="left-pad">{{ row.patientName }} {{ row.patientGender | dictText("Gender") }} {{ row.patientAge }}</el-link>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </hic-dialog>
</template>
<script>
  import { mapGetters, apiFuns } from "sw-hic";
  export default {
    name: "hic-hospitalization-dialog",
    props: {
      visible: Boolean,
      consultations: Array,
      condition: Object,
      entity: Object,
      defaultTab: String,
      diagnosisTabName: String,
      redirectName: { type: String, default: "patient" },
    },
    components: {
      "hic-hospitalization-tags": () => import("./tags-hospitalization.vue"),
    },
    data() {
      return {
        meta: {
          showDrawer: false,
        },
        patients: [],
        current: {},
      };
    },
    computed: {
      ...mapGetters(["Enum", "user", "setting"]),
    },
    methods: {
      open() {
        if (this.entity) {
          this.switchPatient(this.entity);
        }
        if (this.defaultTab) {
          this.$router.replace({ name: this.defaultTab });
        } else {
          this.$router.replace({ name: "patientInfo" });
        }
        let con = this.$utils.Obj.clone(this.condition);
        delete con.pageSize;
        delete con.pageIndexOnView;
        delete con.pageIndex;
        apiFuns.get(`/api/ip/hospitalization`, con).then((res) => {
          this.patients = res.items;
        });
      },
      switchPatient(row) {
        this.current = row;
        this.meta.showDrawer = false;
      },
      menuClick(task) {
        this.$router.replace({ name: task });
      },
      close() {
        this.$emit("close");
        // this.$nextTick(() => {
        //   this.$emit("update:visible", false);
        //   this.$router.replace({ name: this.redirectName });
        // });
      },
    },
  };
</script>
